import iconMap from '../../utils/MaterialCommunityIconMap';

const glyphToUnicode = (glyphNumber) => {
	return String.fromCodePoint(glyphNumber);
};

export default function MaterialCommunityIcons({ name="", size=12, color="white" }) {
	const glyphNumber = iconMap[name];

	return (
		<h1 style={{ fontFamily: "MaterialCommunityIcons", fontSize: size, color }}>{glyphToUnicode(glyphNumber)}</h1>
	);
}